import { CxfEvents } from '@goodgamestudios/cxf-events'
import { WebshopEvents } from './types'
import { IDictionary } from './types/common'
import { GameSpecificConfig } from './types/config'

// Helper to parse BASE_URL - handles both esbuild define (object) and jest (JSON string)
const parseBaseUrl = (value: string | Record<string, string> | undefined): Record<string, string> => {
    if (typeof value === 'string') {
        try {
            return JSON.parse(value) as Record<string, string>
        } catch {
            return { default: value }
        }
    }
    return (value as Record<string, string>) || { default: '' }
}

const COMMON_CONFIG = {
    CANVAS_AGENT_URL: process.env.CANVAS_AGENT_URL as string,
    CANVAS_APP_ID_BY_GAME: process.env.CANVAS_APP_ID_BY_GAME as string | Record<string, string>,
    CUSTOMIZATION_URL: process.env.CUSTOMIZATION_URL as string,
    CUSTOMIZATION_URL_TEMPLATE: process.env.CUSTOMIZATION_URL_TEMPLATE as string,
    BASE_URL: parseBaseUrl(process.env.BASE_URL),
    CXF_DIALOG_OPEN: 'cxf.dialog.open',
    CXF_DIALOG_CLOSE: 'cxf.dialog.close',
    CXF_TRACK_MSG: 'cxf.tracking.message',
    CXF_BTN_CLICK_MSG: CxfEvents.OpenIGS,
    CXF_OPEN_SALES_MSG: WebshopEvents.CXF_OPEN_SALES_MSG,
    WEB_SHOP_CALL_TRACK_ID: 1181,
    CXF_ERROR: 'cxf.error',
    CXF_PUSH: 'cxf.push',
    CXF_AD_STATUS: 'cxf.adBanner.status',
}

export type Config = typeof COMMON_CONFIG & GameSpecificConfig

const GAME_SPECIFIC_CONFIG: IDictionary<GameSpecificConfig> = {
    12: {
        LEGEND_LEVEL_IS_USED: true,
    },
    15: {
        LEGEND_LEVEL_IS_USED: false,
    },
    16: {
        LEGEND_LEVEL_IS_USED: true,
    },
}

export const createConfig = (gameId: string): Config => {
    return {
        ...COMMON_CONFIG,
        ...GAME_SPECIFIC_CONFIG[gameId],
    }
}

/**
 * Get the BASE_URL for a specific game ID
 * @param gameId - The game ID (12, 15, 16, etc.)
 * @returns The BASE_URL string for the game, or default if not found
 */
export const getBaseUrlForGame = (gameId: string | number): string => {
    const baseUrl = COMMON_CONFIG.BASE_URL
    const gameIdKey = String(gameId)
    return baseUrl[gameIdKey] || baseUrl.default || ''
}
